import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckmarkDouble = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_900_20320",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_900_20320)",
		children: /* @__PURE__ */ _jsx("path", { d: "M6.7 17.6536L1.39618 12.3498L2.46538 11.2959L6.71538 15.5459L7.06158 15.1998L8.11538 16.2536L6.7 17.6536ZM12.35 17.6536L7.04618 12.3498L8.1 11.2806L12.35 15.5306L21.55 6.33057L22.6038 7.39977L12.35 17.6536ZM12.0038 12.3498L10.9346 11.2959L15.8846 6.34594L16.9538 7.39977L12.0038 12.3498Z" })
	})]
});
export default SvgCheckmarkDouble;
